<template>
	<div class="footer">
		<div class="footer-head"></div>
		<div class="footer-body">
			<div class="container">

				<div class="logo flex justify-between align-center">
					<div><img src="../assets/footer_logo.png" alt=""></div>
					<div class="links">
						<ul>
							<li>
								<!-- <a href="/about?menuPosition=1482177924603916289">关于我们</a> -->
								<router-link :to="{path:'/about',query:{menuPosition:'1482177924603916289'}}">关于我们
								</router-link>
							</li>
							<!-- <li>·</li>
							<li><a href="">联系我们</a></li>
							<li>·</li>
							<li><a href="">法律声明</a></li>
							<li>·</li>
							<li><a href="">常见问题</a></li> -->
						</ul>
					</div>
				</div>

				<div class="line"></div>

				<div class="info flex justify-between">
					<div>
						<div class="text-white opacity-5">服务时间</div>
						<div class="text-white margin-top-15">
							<div>周一</div>
							<span style="letter-spacing:2px;">(AM/09:00-12:00 | PM/13:00-17:00)</span>
						</div>
						<div class="margin-top-15"></div>
						<div class="text-white ">
							<div>周二 - 周五</div>
							<span style="letter-spacing:2px;">(AM/08:30-11:30 | PM/13:00-17:00)</span>
						</div>
					</div>
					<!-- <a-popover>
						<template slot="content">

						</template>
						<div class="phone">
							<div class="text-white opacity-5 flex justify-between align-center">
								<span>{{defaultDepartment}}</span><img width="20" height="20" src="../assets/list.png" alt="">
							</div>
							<div class="text-white">{{defaultPhone}}</div>
						</div>
					</a-popover> -->
					<div>
						<vue-seamless-scroll :data="phoneList" :class-option="seamlessScrollOption" style="
						          height: 200px;
						          overflow: hidden;
						          width: 200px;
						        ">
							<div class="font-18 padding-10" v-for="(item,index) in phoneList" :key="index">
								<div class="text-white">{{item.department}}</div>
								<div class="text-white">{{item.phone}}</div>
							</div>
						</vue-seamless-scroll>

					</div>
					<div>
						<div class="text-white opacity-5">公司地址</div>
						<div class="text-white margin-top-15">河北省石家庄市维明南大街1号钻石广场17-18楼</div>
					</div>
					<!-- <div>
						<div class="text-white opacity-5">邮编</div>
						<div class="text-white">050000</div>
					</div> -->
					<div>
						<img src="../assets/mp_qrcode.png" style="width: 120px;height: 120px;" alt="">
					</div>
				</div>

			</div>
			<div class="line"></div>

			<div class="copyright text-white">
				<div class="container">
					<a class="text-white" target="_blank"
						href="https://beian.miit.gov.cn/#/Integrated/index">冀ICP备13017039号-1</a>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import vueSeamlessScroll from 'vue-seamless-scroll'
	export default {
		components: {
			vueSeamlessScroll
		},
		data() {
			return {
				phoneList: [],
				defaultPhone: "",
				defaultDepartment: ""
			}
		},
		mounted() {
			this.queryContactPhoneList();
		},
		computed: {
			seamlessScrollOption() {
				return {
					step: 0.2, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
				};
			}
		},
		methods: {
			queryContactPhoneList() {
				this.$request({
					url: this.$api.public.queryContactPhoneList
				}).then((res) => {
					this.phoneList = res.data.result;
					this.defaultPhone = this.phoneList[0].phone;
					this.defaultDepartment = this.phoneList[0].department;
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.footer {
		width: 100%;
	}

	.footer .footer-head {
		width: 100%;
		height: 10px;
		background: #13B8EE;
		opacity: 1;
		border-radius: 0px;
	}

	.footer .footer-body {
		width: 100%;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.logo {
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.logo .links ul {
		margin: 0;
		padding: 0;
		display: flex;
		align-items: center;
	}

	.logo .links ul li {
		list-style: none;
		margin-left: 10px;
		font-size: 18px;
		color: #FFFFFF;
	}

	.logo .links ul li a {
		color: #fff;
	}


	.footer .footer-body .line {
		width: 100%;
		height: 1px;
		background: rgba(255, 255, 255, 0.2);
		opacity: 1;
		border-radius: 0px;
	}

	.info {
		font-size: 16px;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.copyright {
		height: 58px;
		line-height: 58px;
		text-align: center;
	}

	.phone {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/BaseFooter.vue